<div class="coming-soon-modal">
    <div class="text-center">
        <img *ngIf="data?.isPropackage" class="img" src="assets/img/coming-soon-icon.svg" alt="">
        <h3 *ngIf="data?.isPropackage">{{data?.message2}}</h3>
        <p>{{data?.message1}}</p>
        <button class="btn-link" type="button" (click)="onClose(data?.direction)">{{data?.btnname}}</button>

        <button *ngIf="data?.isClose" class="btn-link" type="button" (click)="Close()">Close</button>

        <div *ngIf="data?.purchaseAgain">
            <button class="btn-link" type="button" (click)="purchaseAgain()">Purchase again</button>
        </div>
        <div *ngIf="data?.purchaseAgain">
            <button class="explore" type="button" (click)="explorePackages()">Explore other packages</button>
        </div>
    </div>
</div>
